export default {"src":"/_next/static/media/profile-pro.ab8a730f.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};